import { render, staticRenderFns } from "./ApprovalType.vue?vue&type=template&id=3f3a283e&"
import script from "./ApprovalType.vue?vue&type=script&lang=js&"
export * from "./ApprovalType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f3a283e')) {
      api.createRecord('3f3a283e', component.options)
    } else {
      api.reload('3f3a283e', component.options)
    }
    module.hot.accept("./ApprovalType.vue?vue&type=template&id=3f3a283e&", function () {
      api.rerender('3f3a283e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Approval/ApprovalType/ApprovalType.vue"
export default component.exports